module.exports = "/build/admin/images/apple-touch-icon-120x120.47983aa5.png";